import { Component, Input } from '@angular/core';

import { CommonModule } from '@angular/common';
import { ComponentHeaderComponent } from '../component-header/component-header.component';
import { SafeHtmlPipe } from '@finder/shared/utils/pipes/safe-html/safe-html.pipe';
import { PictureComponent } from '../picture/picture.component';

@Component({
    selector: 'finder-infographic',
    standalone: true,
    imports: [
        CommonModule,
        ComponentHeaderComponent,
        SafeHtmlPipe,
        PictureComponent,
    ],
    templateUrl: './infographic.component.html',
    styleUrl: './infographic.component.scss'
})
export class InfographicComponent {
    @Input() data: any;
}
